import { ErrorHandler } from '@angular/core';

export class DumbErrorHandler implements ErrorHandler {
  handleError(error: Error) {
    if (!error.stack?.toString().includes('spartan-ng')) {
      console.error(error)
    }
  }
}
